/**
 * @file
 * A JavaScript file to set up accordions.
 *
 */

(function (Drupal, $) {

  var event = (navigator.userAgent.match(/iPhone/i)) ? "touchstart" : "click";

  Drupal.behaviors.courses = {
    attach: function (context) {
      // Move the holiday weeks into the correct location
      // $('.holiday-week.afterweek1').each(function() {
      //   $('.holiday-week.afterweek1').insertAfter($(this).parent().find('.week-1'));
      // });
      // $('.holiday-week.afterweek2').each(function() {
      //   $('.holiday-week.afterweek2').insertAfter($(this).parent().find('.week-2'));
      // });
      // $('.holiday-week.afterweek3').each(function() {
      //   $('.holiday-week.afterweek3').insertAfter($(this).parent().find('.week-3'));
      // });
      // $('.holiday-week.afterweek4').each(function() {
      //   $('.holiday-week.afterweek4').insertAfter($(this).parent().find('.week-4'));
      // });
      // $('.holiday-week.afterweek5').each(function() {
      //   $('.holiday-week.afterweek5').insertAfter($(this).parent().find('.week-5'));
      // });
      // $('.holiday-week.afterweek6').each(function() {
      //   $('.holiday-week.afterweek6').insertAfter($(this).parent().find('.week-6'));
      // });
      // $('.holiday-week.afterweek7').each(function() {
      //   $('.holiday-week.afterweek7').insertAfter($(this).parent().find('.week-7'));
      // });
      // $('.holiday-week.afterweek8').each(function() {
      //   $('.holiday-week.afterweek8').insertAfter($(this).parent().find('.week-8'));
      // });
      // $('.holiday-week.afterweek9').each(function() {
      //   $('.holiday-week.afterweek9').insertAfter($(this).parent().find('.week-9'));
      // });
      // $('.holiday-week.afterweek10').each(function() {
      //   $('.holiday-week.afterweek10').insertAfter($(this).parent().find('.week-10'));
      // });
      // $('.holiday-week.afterweek11').each(function() {
      //   $('.holiday-week.afterweek11').insertAfter($(this).parent().find('.week-11'));
      // });
      // $('.holiday-week.afterweek12').each(function() {
      //   $('.holiday-week.afterweek12').insertAfter($(this).parent().find('.week-12'));
      // });
      // $('.holiday-week.afterweek13').each(function() {
      //   $('.holiday-week.afterweek13').insertAfter($(this).parent().find('.week-13'));
      // });
      // $('.holiday-week.afterweek14').each(function() {
      //   $('.holiday-week.afterweek14').insertAfter($(this).parent().find('.week-14'));
      // });
      // $('.holiday-week.afterweek15').each(function() {
      //   $('.holiday-week.afterweek15').insertAfter($(this).parent().find('.week-15'));
      // });


      for (i = 1; i < 16; i++) {
        let holiday = '.holiday-week.afterweek'; // ex. will read .holiday-week.afterweek15
        let week = '.week-'; // ex. will read .week-15
        $(holiday+[i]).insertAfter($(holiday+[i]).parent().find(week+[i]));
      }

      // update the week numbers now that the holiday week has been inserted
      $('.week').each(function() {
        var position = $(this).index() + 1;
        $(this).find('span.week-number').text(position);
      });

      // Anchor link navigation - move to utilities
      // $(document).on('click', 'a[href^="#"]', function (event) {
      //   // uncomment below if we want to eliminate the anchor from the url during smooth scroll
      //   event.preventDefault();
      //
      //   // uncomment below if we want to enable smooth scroll
      //   $('html, body').animate({
      //     scrollTop: $($.attr(this, 'href')).offset().top - 20
      //   }, 750);
      //
      // });

      // BTP arrow displays as soon as scrolling starts
      $(window).scroll(function() {
        if($(this).scrollTop() < 150) {
          $("#scroll-top-wrapper").slideUp();
        }
        else {
          $("#scroll-top-wrapper").slideDown();
        }
      });

      // back to top scroll button
      $("#scroll-top").click(function() {
        $('html, body').animate({ scrollTop: 0 }, 750);
      });

    }
  };

} (Drupal, jQuery));
